import './archived-loan-details.dialog.component.scss'
import {ArchivedBorrower} from "../../../customers/model/ArchivedBorrower";
import {CustomerInfoOptions} from "../../model/CustomerInfoOptions";

export class ArchivedLoanDetailsDialog {

    static instance = (archivedLoanBorrower: ArchivedBorrower) => ({
        template: require('./archived-loan-details.dialog.component.html'),
        controller: [
            'archivedLoanBorrower',
            '$mdDialog',
            ArchivedLoanDetailsDialog
        ],
        controllerAs: '$ctrl',
        clickOutsideToClose: true,
        locals: {
            archivedLoanBorrower: archivedLoanBorrower
        }
    });

    private options: CustomerInfoOptions;

    constructor(private archivedLoanBorrower: ArchivedBorrower,
                private $mdDialog: angular.material.IDialogService) {
    }

    $onInit() {
        this.initCustomerInfoOptions();
    }

    private initCustomerInfoOptions() {
        this.options = {
            readonly: true
        }
    }

    closeDialog = () => {
        this.$mdDialog.hide();
    }

}